import React from 'react';

const Title: React.FC<any> = (props): JSX.Element =>
    <h1 className={`grid-title mb-5 mt-0 ${props.className}`}>
        {props.children}
    </h1>

export default React.memo(Title);
